module.exports = {
    SEARCH_AUTOCOMPLETION_URL: '/api/autocompletesearch',
    ELEM_SEARCH_BAR: 'main-search-box',
}
